import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default function toPdf(element, fileName, ratio, elemHeight, elemWidth, onDownloaded){
  html2canvas(element, {
    height: elemHeight,
    width: elemWidth,
  })
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({ orientation: 'landscape' });
      const width = pdf.internal.pageSize.getWidth();
      const height = ratio * width;

      pdf.addImage(imgData, 'PNG', 0, 0, width, height);
      pdf.save(`${fileName}.pdf`, {returnPromise: true}).then(() => {
        onDownloaded();
      });
    });
};



// WEBPACK FOOTER //
// ./src/helpers/toPdf.js